import React from "react";
import { elementsList } from "../Helper.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import FormBuilderTool from "./FormBuilderTool.js";

const FormBuilderElements = ({ addNewField, formItems, addItemsToCart }) => {
  const { getTextByKey, getHtmlByKey } = useContent();

  return (
    <div className="form-builder-elements-container">
      <div className="info title-form-options">
        <h1>{getTextByKey("create-form-info-title")}</h1>
        <p>{getHtmlByKey("create-form-info1")}</p>
        <p className="disable-form-text">
          {getTextByKey("mobile-disable-design-form")}
        </p>
      </div>

      <div className="elements-container" id="elements-list">
        {elementsList.map((element, index) => (
          <>
            {(element.type === "textstatic" ||
              element.type === "textinput") && (
              <div className="space-statics"></div>
            )}
            <FormBuilderTool
              key={index}
              index={index}
              id={element.type}
              element={element}
              addNewField={addNewField}
              formItems={formItems}
              addItemsToCart={addItemsToCart}
            />
          </>
        ))}
      </div>
    </div>
  );
};

export default FormBuilderElements;
